//@flow

import * as React from 'react';

import { Button, ButtonIcon, Footer } from '@sonyged/ext-proc';

import Constants from './Constants';
import IceContext from './IceContext';

type DayCardProps = {
  active: boolean,
  iceContexts: IceContext[],
  iceContextsIndex: number,
  onClick: number => void,
};

class DayCard extends React.Component<DayCardProps> {
  constructor(props: DayCardProps) {
    super(props);

    (this: any).handleClick = this.handleClick.bind(this);
  }

  handleClick(): void {
    if (this.props.active) {
      this.props.onClick(this.props.iceContextsIndex);
    }
  }

  render() {
    const iceContext = this.props.iceContexts[this.props.iceContextsIndex];
    return (
      <li
        className={'white-bg-color' + (this.props.active ? ' proc-hover proc-button-se' : ' disabled')}
        onClick={this.handleClick}
      >
        <div className="left secondary100-color">
          <div className={'secondary100-color day'}>{Constants.WEEKDAY_LABELS[iceContext.weekday]}</div>

          {this.props.active && (
            <div className="weather">
              <span className={'weather-svg secondary100-fill-color'}>
                {Constants.getWetherSvg(iceContext.weather)}
              </span>
              <span>
                <span className={'proc-huge-font temperature'}>{iceContext.temperature}</span>
                <span className={'proc-medium-font temperature-postfix'}>ど</span>
              </span>
            </div>
          )}
        </div>

        {this.props.active && iceContext.started && (
          <div className="right">
            <div>
              <span className="proc-large-font total gray100-color">{iceContext.totalSales}</span>
              <span className="proc-small-font total-postfix gray100-color">えん</span>
            </div>
            <div>
              <img className="image gray10-bg-color" src={Constants.getPlaceIcon(iceContext.place)} />
              <img className="image gray10-bg-color" src={Constants.getIceImage(iceContext.ice)} />
            </div>
          </div>
        )}
      </li>
    );
  }
}

type Props = {
  wagon: number,
  iceContexts: IceContext[],
  date: number,
  title: string,
  onPreviousClick?: () => void,
  onNextClick: () => void,
  onAnalysisClick: number => void,
};

class ResultContent extends React.Component<Props> {
  constructor(props: Props) {
    super(props);

    (this: any).handleCardClicked = this.handleCardClicked.bind(this);
  }

  handleCardClicked(index: number): void {
    const iceContext = this.props.iceContexts[index];
    if (iceContext.started) {
      this.props.onAnalysisClick(index);
    } else {
      this.props.onNextClick();
    }
  }

  render() {
    return (
      <div className={'proc-ice-field-content result'}>
        <div className={'proc-contents'}>
          <div className={'proc-outer tertiary100-bg-color'}>
            <div className={'proc-inner'}>
              <div className="header">
                <div className="left" />
                <div className="center">
                  <img className="image" src={Constants.getStatusWagonIcon(this.props.wagon)} />
                </div>

                <div className="right total-price">
                  <div>
                    <div>
                      <span className="proc-small-font gray100-color">ごうけい</span>
                    </div>
                    <div>
                      <span className="total gray100-color proc-huge-font">
                        {this.props.iceContexts.reduce((acc, iceContext) => acc + iceContext.totalSales, 0)}
                      </span>
                      <span className="total-postfix gray100-color proc-small-font">えん</span>
                    </div>
                  </div>
                </div>
              </div>
              <ol className="result-list">
                <DayCard
                  active={this.props.date >= 0}
                  iceContexts={this.props.iceContexts}
                  iceContextsIndex={0}
                  onClick={this.handleCardClicked}
                />
                <DayCard
                  active={this.props.date >= 1}
                  iceContexts={this.props.iceContexts}
                  iceContextsIndex={1}
                  onClick={this.handleCardClicked}
                />
                <DayCard
                  active={this.props.date >= 2}
                  iceContexts={this.props.iceContexts}
                  iceContextsIndex={2}
                  onClick={this.handleCardClicked}
                />
                <DayCard
                  active={this.props.date >= 3}
                  iceContexts={this.props.iceContexts}
                  iceContextsIndex={3}
                  onClick={this.handleCardClicked}
                />
              </ol>
            </div>
          </div>
        </div>
        <Footer.nav className="white-bg-color" navItem={this._renderPreviousButton()}>
          <Button.attention onClick={this.props.onNextClick}>つぎへ</Button.attention>
        </Footer.nav>
      </div>
    );
  }

  _renderPreviousButton() {
    if (!this.props.onPreviousClick) {
      return <span />;
    }
    return (
      <Button.normal onClick={this.props.onPreviousClick}>
        <ButtonIcon.back />
      </Button.normal>
    );
  }
}

export default ResultContent;
